module.exports = __webpack_public_path__ + "assets/img/5_1144_big.4d87ee30.jpg";